import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "../auth/auth.service";
import { SessionService } from "../session/session.service";

@Injectable()
export class AccessGuardService implements CanActivate {
  private readonly accessiblePages = ["subscription", "user-profile"];

  constructor(
    private AuthService: AuthService,
    private Router: Router,
    private SessionService: SessionService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    if (this.AuthService.isLoggedIn()) {
      const isAccessiblePage = this.accessiblePages.includes(
        route.routeConfig.path
      );
      if (isAccessiblePage || this.AuthService.isSubscribed()) {
        let currentroute = route;
        while (currentroute.firstChild) {
          currentroute = currentroute.firstChild;
        }
        if (currentroute.data["requiredRole"]) {
          let roles = await this.SessionService.getRoles().first().toPromise();
          if (!roles.includes(currentroute.data["requiredRole"])) {
            this.Router.navigate(["/"]);
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        this.Router.navigate(["/subscription"], {
          queryParams: {
            return: state.url,
          },
        });
        return false;
      }
    } else {
      this.Router.navigate(["/login"], {
        queryParams: {
          return: state.url,
        },
      });
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/access-guard/access-guard.service.ts